import { IComponentOptions } from "angular";
import { LookupModalController } from "./controller";

export const lookupModalComponentOptions: IComponentOptions = {
  controller: LookupModalController,
  controllerAs: "componentController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    resolve: "<",
    modalInstance: "<",
  },
};
